module.exports = __webpack_public_path__ + "static/media/proportion.81a5d524.png";